import { render, staticRenderFns } from "./BusinessCashDetail.vue?vue&type=template&id=0cd67448&scoped=true&"
import script from "./BusinessCashDetail.vue?vue&type=script&lang=js&"
export * from "./BusinessCashDetail.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCashDetail.vue?vue&type=style&index=0&id=0cd67448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd67448",
  null
  
)

export default component.exports